export class EditCollectionPointAddDumpstersInput {
  collectionPointId: number;
  dumpsters: number[];

  constructor(collectionPointId: number, dumpstes: number[]) {
    this.collectionPointId = collectionPointId;
    this.dumpsters = dumpstes;
  }
}
